import "./ContactUs.scss";
import { useState, useEffect } from "react";
import { InputAdornment, TextField, useMediaQuery } from "@mui/material";
import ShowUser from "./../../assets/show-user.svg";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { ContactColumns } from "../../SourceData";
import { DatePicker } from "antd";
import AddGif from "./../../assets/add-gif.gif";
import BlueButton from "../../components/BlueButton/BlueButton";
import api from "../../utils/api";
const { RangePicker } = DatePicker;

const ContactUs = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [query, setQuery] = useState("");
  const [view, setView] = useState("admins");
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    fetchNotifications();
  }, [query, dateRange, page, pageSize]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      // Build query parameters
      const params = new URLSearchParams({
        page: page + 1, // Convert 0-based to 1-based page numbering
        limit: pageSize, // Changed from per_page to limit based on your API response
      });

      const res = await api.get(`/contacts?${params.toString()}`);
      setNotifications(res.data.data || []);
      setTotalRows(res.data.total || 0);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        // Reset to first page when search/filter changes
        setPage(0);
        fetchNotifications();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, dateRange]);

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  // const actionColumn = [
  //   {
  //     field: "action",
  //     headerName: "",
  //     headerAlign: "right",
  //     align: "left",
  //     flex: 1,
  //     renderCell: (params) => {
  //       return (
  //         <div className="cell-action" style={{ justifyContent: "flex-end" }}>
  //           <Link className="cell-btn">
  //             <img src={ShowUser} alt="" />
  //           </Link>
  //           {/* <div
  //             className="cell-btn"
  //             onClick={() => {
  //               setSelectedNotificationId(params.row.id);
  //               setOpenDelete(true);
  //             }}
  //           >
  //             <img src={DeleteUser} alt="" />
  //           </div> */}
  //         </div>
  //       );
  //     },
  //   },
  // ];

  return (
    <div className="users">
      <div className="special-header">
        <p className="title">تواصل معنا</p>
      </div>

      <div className="container">
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={ContactColumns}
          rows={notifications?.map((row, index) => {
            return { ...row, index: index + 1 };
          })}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          loading={loading}
          paginationMode="server"
          rowCount={totalRows}
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page,
            pageSize,
          }}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </div>
    </div>
  );
};

export default ContactUs;
